import { render, staticRenderFns } from "./ProcesosRetrabajo.vue?vue&type=template&id=3ae5b070&"
import script from "./ProcesosRetrabajo.vue?vue&type=script&lang=js&"
export * from "./ProcesosRetrabajo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports